<mat-dialog-content>
  <div class="container" fxLayout="column">
    <h2>Higher Logic Community Integration</h2>

    <mat-radio-group class="radio-buttons" [(ngModel)]="create">
      <div fxLayout="column" class="radio-style">
        <mat-radio-button color="primary" [value]="true"
          >Create a new Higher Logic Community</mat-radio-button
        >
        <span class="radio-button-style">
          The new Higher Logic Community will have the same name as this
          team.</span
        >
      </div>
      <div fxLayout="column" class="radio-style">
        <mat-radio-button color="primary" [value]="false"
          >Link to an existing Community</mat-radio-button
        >
        <span class="radio-button-style">
          People on this team will be added to an existing Higher Logic
          Community.</span
        >
      </div>
    </mat-radio-group>

    @if (!create) {
      <mat-form-field appearance="outline" floatLabel="always">
        <mat-label>Select existing community</mat-label>
        <mat-select [(ngModel)]="selectedCommunity">
          @for (community of communities; track community) {
            <mat-option [value]="community">
              {{ community.name }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <div>
      <button
        mat-flat-button
        color="primary"
        appThrottleClick
        (throttledClick)="createCommunity()"
      >
        @if (create) {
          <span>Create Community</span>
        }
        @if (!create) {
          <span>Link Community</span>
        }
      </button>
      <button type="button" mat-stroked-button mat-dialog-close>Cancel</button>
    </div>
  </div>
</mat-dialog-content>
